import React from 'react';
import './index.css';
import { FaSailboat, FaX } from 'react-icons/fa6';
import { FaFireAlt } from 'react-icons/fa';
import { BattleshipMove, BattleshipTileState } from '../../../../../types/types';

/**
 * Component to display a battleship tile based on the state.
 * @param state The state of the tile.
 * @param isOpponentBoard If this tile is being shown on the opponent's board.
 * @param handleClick Function to handle clicking on the tile.
 * @param tileMove This tile's coordinates if the player were to make a move on it.
 * @returns A React component rendering a battleship tile.
 */
const BattleshipTile = ({
  state,
  isOpponentBoard,
  handleClick,
  tileMove,
}: {
  state: BattleshipTileState;
  isOpponentBoard: boolean;
  handleClick: (move: BattleshipMove) => void;
  tileMove: BattleshipMove;
}) => {
  const renderIcon = () => {
    switch (state) {
      case 'SHIP':
        return isOpponentBoard ? null : <FaSailboat className='ship-icon' />;
      case 'HIT_EMPTY':
        return <FaX className='miss-marker' />;
      case 'HIT_SHIP':
        return <FaFireAlt className='hit-marker' />;
      case 'EMPTY':
      default:
        return null;
    }
  };

  return (
    <button
      className='battleship-tile'
      onClick={() => handleClick(tileMove)}
      disabled={!isOpponentBoard || state === 'HIT_EMPTY' || state === 'HIT_SHIP'}>
      {renderIcon()}
    </button>
  );
};

export default BattleshipTile;
